<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >

                <template slot-scope="scope" slot="menuLeft">
                    <el-button type="primary"
                               icon="el-icon-plus"
                               size="small"
                               plain
                               @click.stop="open()"
                    >新增
                    </el-button>
                </template>
                <template slot-scope="scope" slot="menu">
                    <el-button type="primary"
                               icon="el-icon-edit"
                               size="small"
                               plain
                               @click.stop="editOpen(scope.row)"
                    >编辑
                    </el-button>
                    <el-button type="danger"
                               icon="el-icon-delete"
                               size="small"
                               plain
                               @click.stop="handleDel(scope.row.id)">删除
                    </el-button>
                </template>
            </avue-crud>
            <template>
                <el-dialog title="新增" :visible.sync="dataDialog">
                    <div class="bigbox">
                        <div class="listbox">
                            <span class="spans">规则名称:</span>
                            <el-input v-model="data.ruleName" placeholder="请输入规则名称"></el-input>
                        </div>
                        <div class="listbox">
                            <span class="spans">渠道:</span>
                            <el-select v-model="channel"
                                       placeholder="请选择渠道"
                                       required
                                       @change="changeChannelType(channel.value)"
                                       value-key="value">
                                <el-option v-for="channel in channelTypes" :key="channel.value"
                                           :label="channel.label"
                                           :value="channel"></el-option>
                            </el-select>
                        </div>
                        <div class="listbox">
                            <span class="spans">省:</span>
                            <el-select v-model="province"
                                       placeholder="请选择省"
                                       required
                                       clearable
                                       @change="findCities(province.id)"
                                       value-key="id">
                                <el-option v-for="province in provinces" :key="province.id" :label="province.name"
                                           :value="province"></el-option>
                            </el-select>
                        </div>
                        <div class="listbox">
                            <span class="spans">市:</span>
                            <el-select v-model="city"
                                       placeholder="请选择市"
                                       clearable
                                       required
                                       @change="findAreas(city.id)"
                                       value-key="id">
                                <el-option v-for="city in cities" :key="city.id" :label="city.name"
                                           :value="city"></el-option>
                            </el-select>
                        </div>
                        <div class="listbox">
                            <span class="spans">区:</span>
                            <el-select v-model="area"
                                       placeholder="请选择区"
                                       clearable
                                       required
                                       value-key="id">
                                <el-option v-for="area in areas" :key="area.id" :label="area.name"
                                           :value="area"></el-option>
                            </el-select>
                        </div>
                        <div class="listbox" v-if="goodsFlag">
                            <span class="spans">商品:</span>
                            <el-select v-model="goods"
                                       placeholder="请选择商品"
                                       required
                                       value-key="id">
                                <el-option v-for="goods in goodsList" :key="goods.id" :label="goods.name"
                                           :value="goods"></el-option>
                            </el-select>
                        </div>
                        <div class="listbox" v-if="workOrderFlag">
                            <span class="spans">服务类目:</span>
                            <el-select v-model="joinsWorkServiceCategory"
                                       placeholder="请选择服务类目"
                                       required
                                       @change="choseWorkServiceItem"
                                       value-key="id">
                                <el-option v-for="joinsWorkServiceCategory in joinsWorkServiceCategorys"
                                           :key="joinsWorkServiceCategory.id" :label="joinsWorkServiceCategory.name"
                                           :value="joinsWorkServiceCategory"></el-option>
                            </el-select>
                        </div>
                        <div class="listbox" v-if="workOrderFlag">
                            <span class="spans">服务项目:</span>
                            <el-select v-model="joinsWorkServiceItem"
                                       placeholder="请选择服务项目"
                                       required
                                       value-key="id">
                                <el-option v-for="joinsWorkServiceItem in joinsWorkServiceItems"
                                           :key="joinsWorkServiceItem.id"
                                           :label="joinsWorkServiceItem.name"
                                           :value="joinsWorkServiceItem"></el-option>
                            </el-select>
                        </div>
                        <div class="listbox" v-if="promoteCustomerFlag">
                            <span class="spans">推广人类型</span>
                            <el-select v-model="promoteCustomerType"
                                       placeholder="请选择推广人类型"
                                       required
                                       value-key="value">
                                <el-option v-for="promoteCustomerType in clientTypes" :key="promoteCustomerType.value"
                                           :label="promoteCustomerType.label"
                                           :value="promoteCustomerType"></el-option>
                            </el-select>
                        </div>
                        <div class="listbox" v-if="promoteCustomerFlag">
                            <span class="spans">上级佣金比例：</span>
                            <el-input v-model="data.parentCommissionRate" placeholder="请输入上级佣金比例"></el-input>
                        </div>
                        <div class="listbox" v-if="promoteCustomerFlag">
                            <span class="spans">佣金比例：</span>
                            <el-input v-model="data.commissionRate" placeholder="请输入佣金比例"></el-input>
                        </div>
                        
                        <div class="listbox">
                            <span class="spans">优惠券:</span>
                            <el-select v-model="productCoupon"
                                       placeholder="请选择优惠券"
                                       required
                                       multiple
                                       value-key="id">
                                <el-option v-for="productCoupon in productCouponList" :key="productCoupon.id"
                                           :label="productCoupon.couponName"
                                           :value="productCoupon"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="buttons">
                        <el-button type="info" plain @click.stop="close">取消</el-button>
                        <el-button type="primary" v-if="flag=='add'" style="margin-right:10px;"
                                   @click.stop="handleSave">确定
                        </el-button>
                        <el-button type="primary" v-if="flag=='edit'" style="margin-right:10px;"
                                   @click.stop="handleUpdate">修改
                        </el-button>
                    </div>
                </el-dialog>
            </template>
        </basic-container>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { couponRuleOption } from "@/const/salesCloud/couponRuleOption";
import {
  findCouponRules,
  findProvince,
  findCities,
  findAreas,
  addCouponRules,
  updateCouponRules,
  deleteCouponRules,
  findProductCoupon
} from "@/api/salesCloud/couponRule";
import {
  findCategoryAll,
  findItemsByCategory
} from "@/api/salesCloud/workOrder";
import { findProductGoods } from "@/api/salesCloud/productGoods";
import { DIC } from "@/const/dic";

export default {
  name: "couponRule",
  components: {},
  data() {
    return {
      tableOption: couponRuleOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      },
      dataDialog: false,
      data: {},
      flag: "",
      province: {},
      provinces: [],
      city: {},
      cities: [],
      area: {},
      areas: [],
      goods: {},
      goodsList: [],
      joinsWorkServiceCategorys: [],
      joinsWorkServiceCategory: {},
      joinsWorkServiceItems: [],
      joinsWorkServiceItem: {},
      clientTypes: DIC.CLIENT_TYPE,
      promoteCustomerType: {},
      channelTypes: DIC.CHANNEL_TYPE,
      channel: {},
      goodsFlag: false,
      workOrderFlag: false,
      promoteCustomerFlag: false,
      productCoupon: [],
      productCouponList: [],
      row: {}
    };
  },
  created() {
    findProvince().then(res => {
      this.provinces = res.data;
    });
    findProductGoods().then(res => {
      let data = JSON.parse(res.data);
      this.goodsList = data.rows;
    });
    findProductCoupon().then(res => {
      let data = JSON.parse(res.data);
      this.productCouponList = data.rows;
    });
    findCategoryAll().then(res => {
      let data = JSON.parse(res.data);
      this.joinsWorkServiceCategorys = data.rows;
    });
    this.handleList();
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["permission"])
  },
  props: [],
  methods: {
    changeChannelType(obj) {
      if (obj == "WORK_ORDER") {
        this.goodsFlag = false;
        this.workOrderFlag = true;
        this.promoteCustomerFlag = false;
        this.goods = {};
        this.promoteCustomerType = {};
        this.data.commissionRate = "";
        this.data.parentCommissionRate="";
      }
      if (obj == "PURCHASE_GOODS") {
        this.goodsFlag = true;
        this.workOrderFlag = false;
        this.promoteCustomerFlag = false;
        this.joinsWorkServiceCategory = {};
        this.joinsWorkServiceItem = {};
        this.promoteCustomerType = {};
        this.data.commissionRate = "";
        this.data.parentCommissionRate="";
      }
      if (obj == "PROMOTING_USERS") {
        this.goodsFlag = false;
        this.workOrderFlag = false;
        this.promoteCustomerFlag = true;
        this.joinsWorkServiceCategory = {};
        this.joinsWorkServiceItem = {};
        this.goods = {};
      }
      if (obj == "LOGIN") {
        this.goodsFlag = false;
        this.workOrderFlag = false;
        this.promoteCustomerFlag = false;
        this.joinsWorkServiceCategory = {};
        this.joinsWorkServiceItem = {};
        this.promoteCustomerType = {};
        this.data.commissionRate = "";
        this.data.parentCommissionRate="";
        this.goods = {};
      }
      if (obj == "USER_LOGIN") {
        this.goodsFlag = false;
        this.workOrderFlag = false;
        this.promoteCustomerFlag = false;
        this.joinsWorkServiceCategory = {};
        this.joinsWorkServiceItem = {};
        this.promoteCustomerType = {};
        this.data.commissionRate = "";
        this.data.parentCommissionRate="";
        this.goods = {};
      }
    },
    choseWorkServiceItem() {
      findItemsByCategory(this.joinsWorkServiceCategory.id).then(res => {
        let data = JSON.parse(res.data);
        this.joinsWorkServiceItems = data;
      });
    },
    findCities(id) {
      this.cities = [];
      this.areas = [];
      this.city = {};
      this.area = {};
      findCities(id).then(res => {
        this.cities = res.data;
      });
    },
    findAreas(id) {
      this.areas = [];
      this.area = {};
      if (id != "" && id != " ") {
        findAreas(id).then(res => {
          this.areas = res.data;
        });
      }
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      (params.page = this.page.currentPage), (params.size = pageSize);
      findCouponRules(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      findCouponRules(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      findCouponRules(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      findCouponRules(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      this.$refs.crud.rowEdit(row, index);
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      findCouponRules(parmas).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave() {
      let data = {};
      data.ruleName = this.data.ruleName;
      data.channel = this.channel.value;
      if (this.channel.value == "WORK_ORDER") {
        data.serviceCategoryId = this.joinsWorkServiceCategory.id;
        data.serviceItemId = this.joinsWorkServiceItem.id;
      }
      if (this.channel.value == "PURCHASE_GOODS") {
        data.goodsId = this.goods.id;
      }
      if (this.channel.value == "PROMOTING_USERS") {
        data.promoteCustomerType = this.promoteCustomerType.value;
        data.commissionRate = this.data.commissionRate;
        data.parentCommissionRate=this.data.parentCommissionRate;
      }
      data.province = this.province.id;
      data.city = this.city.id;
      data.area = this.area.id;
      let couponIds = [];
      for (let i = 0; i < this.productCoupon.length; i++) {
        couponIds.push(this.productCoupon[i].id);
      }
      data.couponList = couponIds;
      addCouponRules(data)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success"
            });
            this.dataDialog = false;
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange() {
      // console.log(val);
      // this.tableRow = val;
      // this.$notify({
      //     showClose: true,
      //     message: JSON.stringify(val),
      //     type: 'success',
      // });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(id) {
      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteCouponRules(id)
            .then(response => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "删除成功",
                  type: "success"
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error"
              });
            });
        })
        .catch(() => {});
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate() {
      let data = {};
      data.id = this.row.id;
      data.ruleName = this.data.ruleName;
      data.channel = this.channel.value;
      if (this.channel.value == "WORK_ORDER") {
        data.serviceCategoryId = this.joinsWorkServiceCategory.id;
        data.serviceItemId = this.joinsWorkServiceItem.id;
      }
      if (this.channel.value == "PURCHASE_GOODS") {
        data.goodsId = this.goods.id;
      }
      if (this.channel.value == "PROMOTING_USERS") {
        data.promoteCustomerType = this.promoteCustomerType.value;
        data.commissionRate = this.data.commissionRate;
        data.parentCommissionRate = this.data.parentCommissionRate;
      }
      data.province = this.province.id;
      data.city = this.city.id;
      data.area = this.area.id;
      let couponIds = [];
      for (let i = 0; i < this.productCoupon.length; i++) {
        couponIds.push(this.productCoupon[i].id);
      }
      data.couponList = couponIds;
      console.log(data);
      // row.rootId = 0
      updateCouponRules(data)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success"
            });
            this.dataDialog = false;
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
    },
    open() {
      this.clean();
      this.flag = "add";
      this.data = {};
      this.dataDialog = true;
    },
    editOpen(row) {
      this.clean();
      this.row = row;
      this.productCoupon = [];
      this.flag = "edit";
      this.data.ruleName = row.ruleName;
      this.channel = this.getChannel(row.channel);
      this.province = { id: row.province };
      this.findCities(row.province);
      this.city = { id: row.city };
      this.findAreas(row.city);
      this.area = { id: row.area };

      for (let i = 0; i < row.couponList.length; i++) {
        console.log(row.couponList[i].couponId);
        let coupon = { id: row.couponList[i].couponId };
        this.productCoupon.push(coupon);
      }
      if (this.channel.value == "WORK_ORDER") {
        this.joinsWorkServiceCategory = { id: row.serviceCategoryId };
        this.joinsWorkServiceItem = { id: row.serviceItemId };
        this.choseWorkServiceItem();
        (this.goodsFlag = false),
          (this.workOrderFlag = true),
          (this.promoteCustomerFlag = false);
      }
      if (this.channel.value == "PURCHASE_GOODS") {
        this.goods = { id: row.goodsId };
        (this.goodsFlag = true),
          (this.workOrderFlag = false),
          (this.promoteCustomerFlag = false);
      }
      if (this.channel.value == "PROMOTING_USERS") {
        this.data.commissionRate = row.commissionRate;
        this.data.parentCommissionRate = row.parentCommissionRate;
        this.promoteCustomerType = this.getPromoteCustomerType(
          row.promoteCustomerType
        );
        (this.goodsFlag = false),
          (this.workOrderFlag = false),
          (this.promoteCustomerFlag = true);
      }
      this.dataDialog = true;
    },
    close() {
      this.dataDialog = false;
    },
    getChannel(val) {
      for (let i = 0; i < this.channelTypes.length; i++) {
        if (val == this.channelTypes[i].value) {
          return this.channelTypes[i];
        }
      }
    },
    getPromoteCustomerType(val) {
      for (let i = 0; i < this.clientTypes.length; i++) {
        if (val == this.clientTypes[i].value) {
          return this.clientTypes[i];
        }
      }
    },
    clean() {
      this.province = {};
      this.city = {};
      this.area = {};
      this.goods = {};
      this.joinsWorkServiceCategory = {};
      this.joinsWorkServiceItem = {};
      this.promoteCustomerType = {};
      this.channel = {};
      this.productCoupon = [];
      this.row = {};
      this.goodsFlag = false;
      (this.workOrderFlag = false), (this.promoteCustomerFlag = false);
    }
  }
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.bigbox {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.listbox {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  width: 400px;
  align-items: center;
  box-sizing: border-box;
}

.buttons {
  display: flex;
  flex-direction: row-reverse;
}

.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.spans {
  width: 150px;
  text-align: right;
  margin-right: 20px;
}
</style>
